import {ReactComponent as EyeIcon} from '@assets/icons/eye.svg';
import {ReactComponent as EyeSlashIcon} from '@assets/icons/eye-slash.svg';
import React from "react";
import {classNames} from "@utils/class-names";

interface ArticleStatusIndicatorProps {
    isVisible: boolean
}

const ArticleStatusIndicator = ({isVisible}: ArticleStatusIndicatorProps) => {

    const visibleClass: string = "bg-success/10 text-success";
    const hiddenClass: string = "bg-error/10 text-error";

    return (
        <div className={classNames(
            !isVisible ? hiddenClass : visibleClass,
            "w-fit flex items-center px-1 rounded-[4px] h-[20px]"
        )}>
            {!isVisible
                ? <EyeSlashIcon className="w-3 h-3 mr-3"/>
                : <EyeIcon className="w-3 h-3 mr-3"/>
            }
            <span className="font-semibold text-sm">
                {!isVisible ? "Ukryty" : "Widoczny"}
            </span>
        </div>
    )
}

export default ArticleStatusIndicator
